// noinspection ExceptionCaughtLocallyJS

import * as constants from '../constants';
import { ACTION, setLoading, wrap } from './index';
import { Dispatch } from 'redux';
import {
  SchemaDeleteOrderUploadedFileQueryParams,
  SchemaGetCampaignDetailsQueryParams,
  SchemaGetCampaignQueryParams,
  SchemaGetCreationOrderQueryParams,
  SchemaGetOrderCompaniesQueryParams,
  SchemaGetProductionOrderQueryParams,
  SchemaPostCreationOrderRequestBody,
  SchemaPostProductionOrderRequestBody,
  SchemaPostUploadFileRequestBody,
} from '@repo/legacy-commerce-api';
import legacyApi from '../middlewares/api';

export const getCampaigns = (params: SchemaGetCampaignQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      const { data, error } = await legacyApi.GET('/campaign', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.GET_CAMPAIGNS, payload: data });
      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

export const getCampaignDetails = (params: SchemaGetCampaignDetailsQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      const { data, error } = await legacyApi.GET('/campaigndetails', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.FETCHED_CAMPAIGN,
        payload: { ...data },
      });
      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

export const postCreationOrder = (payload: SchemaPostCreationOrderRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(
        setLoading({
          value: true,
          name: 'order',
        }),
      );

      const { data, error } = await legacyApi.POST('/creationorder', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      return data;
    } catch (err) {
      dispatch(
        setLoading({
          value: false,
          name: 'order',
        }),
      );
      throw err;
    } finally {
      dispatch(
        setLoading({
          value: false,
          name: 'order',
        }),
      );
    }
  }, 'POST_ERROR');

export const postProductionOrder = (payload: SchemaPostProductionOrderRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(
        setLoading({
          value: true,
          name: 'order',
        }),
      );

      const { data, error } = await legacyApi.POST('/productionorder', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      return data;
    } catch (err) {
      dispatch(
        setLoading({
          value: false,
          name: 'order',
        }),
      );
      throw err;
    } finally {
      dispatch(
        setLoading({
          value: false,
          name: 'order',
        }),
      );
    }
  }, 'POST_ERROR');

export const uploadFile = (formData: SchemaPostUploadFileRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading({ value: true, name: 'upload' }));

      const { data, error } = await legacyApi.POST('/orderupload', { body: formData as never });

      if (error) {
        throw JSON.stringify(error);
      }

      return data;
    } catch (err) {
      dispatch(setLoading({ value: false, name: 'upload' }));
      throw err;
    } finally {
      dispatch(setLoading({ value: false, name: 'upload' }));
    }
  }, 'POST_ERROR');

export const deleteUploadedFile = (payload: SchemaDeleteOrderUploadedFileQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      const { data, error } = await legacyApi.DELETE('/orderuploadedfile', { params: { query: payload as never } });

      if (error) {
        throw JSON.stringify(error);
      }

      return data;
    } catch (err) {
      throw err;
    }
  }, 'DELETE_ERROR');

export const getCreationOrder = (params: SchemaGetCreationOrderQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      const { data, error } = await legacyApi.GET('/creationorder', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.GET_CREATION_ORDER,
        payload: { ...data },
      });
      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

export const getProductionOrder = (params: SchemaGetProductionOrderQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));
      const { data, error } = await legacyApi.GET('/productionorder', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.GET_PRODUCTION_ORDER,
        payload: { ...data },
      });
      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

export const orderCompanies = (params: SchemaGetOrderCompaniesQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      const { data, error } = await legacyApi.GET('/ordercompany', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.GET_ORDER_COMPANY, payload: data });
      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

export const getCustomersForAgency = () =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading({ value: true, name: 'sujet' }));

      const { data, error } = await legacyApi.GET('/customer');

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.FETCHED_CUSTOMERS,
        payload: { ...data },
      });
      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading({ value: false, name: 'sujet' }));
      throw err;
    } finally {
      dispatch(setLoading({ value: false, name: 'sujet' }));
    }
  }, constants.FETCH_ERROR);

export const selectCustomer = (payload: any): ACTION => ({
  type: constants.SELECT_CUSTOMER,
  payload,
});

export const setAgencyInfoPanelVisibility = (payload: any): ACTION => ({
  type: constants.SET_AGENCY_INFO_PANEL_VISIBILITY,
  payload,
});

export const setIsAgencyMode = (payload: any): ACTION => ({
  type: constants.SET_IS_AGENCY_MODE,
  payload,
});

export const setAgencyData = (payload: any): ACTION => ({
  type: constants.SET_AGENCY_DATA,
  payload,
});
